export default __webpack_public_path__ + "static/media/baseline-signal_cellular_4_bar-24px.3ab685c8.svg";